import React, { useEffect, useState } from "react";
import axios from "axios";
import BannerSlider from "../components/BannerSlider";
import { MdShoppingCart, MdLocalShipping, MdSecurity, MdLocalOffer, MdStar } from "react-icons/md";
import { FaHandsHelping, FaGlobe, FaUsers } from "react-icons/fa";
import CountUp from "react-countup";
import { useInView } from "react-intersection-observer";
import base_url from "../utils/axiosConfig"


const About = () => {
  const [about, setAbout] = useState("");
  const [totalProducts, setTotalProducts] = useState(0);
  const [totalCustomers, setTotalCustomers] = useState(0);

  // Trigger animation when stats come into view
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.2,
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        // About content
        const aboutRes = await axios.get(`${base_url}master/getabout`);
        if (aboutRes.data && aboutRes.data.length > 0) {
          setAbout(aboutRes.data[0].name);
        }

        // Products count
        const productsRes = await axios.get(`${base_url}Products`);
        if (productsRes.data) {
          setTotalProducts(productsRes.data.products?.length || 0);
        }

        // Customers count
        const usersRes = await axios.get(`${base_url}user/all-users`);
        if (usersRes.data) {
          setTotalCustomers(usersRes.data.length || 0);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {/* Hero Section */}
      <section className="policy-wrapper py-5 home-wrapper-2 bg-light">
        <div className="container-xxl">
          <div className="row align-items-center">
          <div className="col-md-6">
              <BannerSlider />
            </div>
            <div className="col-md-6 mb-4 mb-md-0">
              <h1 className="fw-bold display-4">About Our Store</h1>
              <p className="text-muted">
                {about ||
                  "We are your trusted eCommerce destination for high-quality products, seamless shopping, and excellent customer support."}
              </p>
              <a
                href="/product"
                className="btn btn-primary btn-md mt-3 rounded shadow d-inline-flex align-items-center"
              >
                Shop Now
                <span className="px-2">
                  <MdShoppingCart size={22} />
                </span>
              </a>
            </div>
            
          </div>
        </div>
      </section>

      {/* Mission & Vision */}
      <section className="py-5">
        <div className="container-xxl text-center">
          <div className="row g-4">
            <div className="col-md-4">
              <div className="p-4 shadow-sm rounded bg-white h-100">
                <FaHandsHelping size={50} className="text-primary" />
                <h4 className="mt-3">Our Mission</h4>
                <p className="text-muted">
                  To make online shopping simple, fast, and affordable for everyone.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 shadow-sm rounded bg-white h-100">
                <FaGlobe size={50} className="text-success" />
                <h4 className="mt-3">Our Vision</h4>
                <p className="text-muted">
                  To become a global leader in eCommerce with innovation and trust.
                </p>
              </div>
            </div>
            <div className="col-md-4">
              <div className="p-4 shadow-sm rounded bg-white h-100">
                <FaUsers size={50} className="text-warning" />
                <h4 className="mt-3">Our Values</h4>
                <p className="text-muted">
                  Customer satisfaction, transparency, and quality service are at our core.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-5 bg-light">
  <div className="container-xxl text-center">
    <h2 className="fw-bold mb-4">Why Shop With Us?</h2>
    <div className="row g-4">
      <div className="col-6 col-lg-3">
        <div className="card h-100 shadow-sm border-0">
          <div className="card-body">
            <MdLocalShipping size={50} className="text-primary" />
            <h5 className="mt-3">Fast Delivery</h5>
            <p className="text-muted">Quick and reliable shipping across the country.</p>
          </div>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div className="card h-100 shadow-sm border-0">
          <div className="card-body">
            <MdSecurity size={50} className="text-success" />
            <h5 className="mt-3">Secure Payment</h5>
            <p className="text-muted">Your transactions are safe with encrypted systems.</p>
          </div>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div className="card h-100 shadow-sm border-0">
          <div className="card-body">
            <MdLocalOffer size={50} className="text-warning" />
            <h5 className="mt-3">Best Deals</h5>
            <p className="text-muted">Affordable prices with amazing discounts.</p>
          </div>
        </div>
      </div>

      <div className="col-6 col-lg-3">
        <div className="card h-100 shadow-sm border-0">
          <div className="card-body">
            <MdStar size={50} className="text-danger" />
            <h5 className="mt-3">Customer Trust</h5>
            <p className="text-muted">Thousands of happy customers trust us daily.</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


      {/* Stats Section */}
      <section className="py-5" ref={ref}>
        <div className="container-xxl text-center">
          <div className="row g-4">
            <div className="col-6 col-md-3">
              <h2 className="fw-bold text-primary">
                {inView && <CountUp end={totalProducts} duration={2} />}+
              </h2>
              <p className="text-muted">Products Available</p>
            </div>
            <div className="col-6 col-md-3">
              <h2 className="fw-bold text-success">
                {inView && <CountUp end={totalCustomers} duration={2} />}+
              </h2>
              <p className="text-muted">Happy Customers</p>
            </div>
            <div className="col-6 col-md-3">
              <h2 className="fw-bold text-warning">
                {inView && <CountUp end={99} duration={2} />}%
              </h2>
              <p className="text-muted">Positive Reviews</p>
            </div>
            <div className="col-6 col-md-3">
              <h2 className="fw-bold text-danger">24/7</h2>
              <p className="text-muted">Customer Support</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
